import React from 'react'

interface ReviewIconProps {
  color?: string
  gradient?: boolean
  width?: number
  height?: number
  alt?: string
}

const ReviewIcon: React.FC<ReviewIconProps> = ({
  color = '#000',
  gradient,
  width = 22,
  height = 22,
  alt = 'Review icon',
}) => {
  const gradientColors = { start: '#ed1c24', end: '#27aae1' }

  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={width}
      height={height}
      fill='none'
      viewBox='0 0 22 22'
      aria-label={alt}
    >
      <title>{alt}</title>
      {gradient ? (
        <defs>
          <linearGradient id='grad1' x1='0%' y1='0%' x2='100%' y2='0%'>
            <stop offset='0%' style={{ stopColor: gradientColors.start, stopOpacity: 1 }} />
            <stop offset='100%' style={{ stopColor: gradientColors.end, stopOpacity: 1 }} />
          </linearGradient>
        </defs>
      ) : null}
      <path
        fill={gradient ? 'url(#grad1)' : color}
        d='M21.365 17.134h-6.028a2.435 2.435 0 00-2.433 2.432c0 .642-.522 1.164-1.164 1.164H2.433a1.165 1.165 0 01-1.164-1.164v-.847c0-.641.522-1.163 1.163-1.163l1.677-.001h.002c.02 0 .038-.001.058-.003.008 0 .015-.002.023-.003l.025-.003 4.479-.773.007-.001.02-.005a.515.515 0 00.034-.008l.023-.007a.934.934 0 00.03-.01l.023-.009a.727.727 0 00.046-.021l.019-.01.031-.02a.724.724 0 00.05-.034c.004-.005.01-.008.015-.013a.585.585 0 00.043-.039L20.349 5.284a2.33 2.33 0 000-3.29L19.036.68a2.33 2.33 0 00-3.291 0L4.433 11.992a.624.624 0 00-.105.14l-.011.02a.705.705 0 00-.02.044l-.01.023a.924.924 0 00-.03.108v.006l-.683 3.953H2.431A2.436 2.436 0 000 18.72v.847A2.436 2.436 0 002.433 22h9.307a2.435 2.435 0 002.433-2.433c0-.641.522-1.163 1.163-1.163h6.03a.635.635 0 100-1.27zM5.3 13.756l1.974 1.974-2.386.412.412-2.386zm9.466-10.3l.956.955-8.986 8.986-.956-.956 8.986-8.986zM8.588 15.25l-.956-.956 8.986-8.985.956.955-8.986 8.986zm8.054-13.672a1.06 1.06 0 011.496 0l1.313 1.313a1.059 1.059 0 010 1.496l-.98.98-2.809-2.81.98-.98z'
      />
    </svg>
  )
}

export default ReviewIcon
